import InfluencerContent from '../../containers/Influencer/InfluencerContent';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import PageLayout from '../UI/PageLayout';
import InfluencerContentPageDropdowns from "./InfluencerContentPageDropdowns";

export default function ContentPage() {
  return (
    <PageLayout
      title="Content"
      dropdowns={<InfluencerContentPageDropdowns />}
      content={<InfluencerContent />}
    />
  );
}